/**
 * Lowercase ISO-ordered weekday names as accepted by the backend
 * (e.g. `RepeatMealOnDaysRequest.days`, `AddMealToSlotRequest.day`).
 */
export const WEEKDAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

export type Weekday = (typeof WEEKDAYS)[number];

/** Three-letter labels for compact UI surfaces (day selector, repeat-meal picker). */
export const WEEKDAY_SHORT_LABELS: Record<Weekday, string> = {
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
  sunday: "Sun",
};

/** Full-name labels for surfaces that have room for them (repeat-meal day list). */
export const WEEKDAY_LONG_LABELS: Record<Weekday, string> = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};
